import React from "react";
import { PanelsTopLeft } from "lucide-react";

import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { SidebarToggle } from "./sidebar-toggle";
import { Menu } from "./menu";
import { useSidebarToggle } from "../../hooks/use-sidebar-toggle";
import { useStore } from "zustand";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import LogoIcon from "../../assets/Frame 2.svg";
// import LogoName from "../../assets/images/logo-name.svg";

export function Sidebar() {
  const user = useSelector((state) => state?.superAdmin?.user);
  const navigate = useNavigate();
  const sidebar = useStore(useSidebarToggle, (state) => state);

  if (!sidebar) return null;

  return (
    <aside
      className={cn(
        "fixed top-0 left-0 z-20 h-screen -translate-x-full lg:translate-x-0 transition-[width] ease-in-out duration-300 bg-sidebar",
        sidebar?.isOpen === false ? "w-[90px]" : "w-72"
      )}
    >
      <SidebarToggle isOpen={sidebar?.isOpen} setIsOpen={sidebar?.setIsOpen} />
      <div className="relative h-full flex flex-col py-4 border-r">
        <Button
          className={cn(
            "transition-transform ease-in-out duration-300 mb-1 hover:no-underline cursor-pointer",
            sidebar?.isOpen === false ? "translate-x-1" : "translate-x-0"
          )}
          variant="link"
          asChild
        >
          <div
            onClick={() => {
              user?.admintype === "Admin" || user?.admintype === "OrganizationAdmin" || user?.admintype === "IndividualAdmin"
                ? navigate("/user")
                : navigate("/admin");
            }}
            className="flex items-center gap-2"
          >
            <div
              className={cn(
                "rounded-full overflow-hidden",
                sidebar?.isOpen === false ? "w-10 h-10" : "w-10 h-10"
              )}
            >
              <img src={LogoIcon} alt="logo" />
            </div>
            <div
              className={cn(
                "text-primary text-lg",
                sidebar?.isOpen === false ? "hidden" : ""
              )}
            >
              GuideproAI
            </div>
          </div>
        </Button>
        <Menu isOpen={sidebar?.isOpen} />
      </div>
    </aside>
  );
}
